// extracted by mini-css-extract-plugin
export var readonly = "_fy-1";
export var star = "_fy-0";